import { DONATION_ROUTES } from '@/constants';
import { getStaticCdnUrl } from '@/utils';
import { checkTodayInRange } from '@/utils/checkTodayInRange';

type CardPromotionConfig = {
  id: string;
  title: string;
  range: readonly [string, string];
  imageUrl: string;
  inlineImageUrl: string;
  inlineAlt: string;
  href: string;
};

const CARD_PROMOTION_CONFIGS: CardPromotionConfig[] = [
  {
    id: 'kb',
    title: 'KB국민카드X웰로',
    range: ['2026-08-01T00:00:00+09:00', '2026-08-31T23:59:59+09:00'],
    imageUrl: getStaticCdnUrl(
      'kb-card-event/donation-home-kb-card-banner-2608.png',
    ),
    inlineImageUrl: getStaticCdnUrl(
      'kb-card-event/donation-order-detail-kb-card-banner-2608.png',
    ),
    inlineAlt: 'KB국민카드 체크카드 이벤트 배너',
    href: DONATION_ROUTES.KB_CHECK_CARD.pathname,
  },
];

// --- Derived exports ---

const activeConfigs = CARD_PROMOTION_CONFIGS.filter((config) =>
  checkTodayInRange(config.range[0], config.range[1]),
);

export const CARD_PROMOTIONS = {
  inline: activeConfigs.map((config) => ({
    href: config.href,
    imageUrl: config.inlineImageUrl,
    alt: config.inlineAlt,
  })),
  main: activeConfigs.map((config) => ({
    imageUrl: config.imageUrl,
    href: config.href,
    title: config.title,
  })),
};
